import { memo } from 'react'
import LoginModal from '@/components/LoginModal/LoginModal'
import { useLoginModal } from '@/store/loginContext'

const GlobalLoginModal = () => {
  const { isLoginModalVisible, hideLoginModal, params } = useLoginModal()

  // 只有在需要显示时才渲染 LoginModal 组件
  if (!isLoginModalVisible) {
    return null
  }

  return <LoginModal visible={isLoginModalVisible} onCancel={hideLoginModal} {...params} />
}

export default memo(GlobalLoginModal)
